import { colors } from '../foundation';

type Props = {
  color?: (typeof colors.red)[100] | typeof colors.primary.white;
};

const LinkedInIcon = ({ color = colors.primary.white }: Props) => (
  <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M22.9875 0.856201H1.0125C0.45 0.856201 0 1.3062 0 1.8687V23.8812C0 24.4062 0.45 24.8562 1.0125 24.8562H23.025C23.5875 24.8562 24.0375 24.4062 24.0375 23.8437V1.8687C24 1.3062 23.55 0.856201 22.9875 0.856201ZM7.125 21.2937H3.5625V9.8562H7.125V21.2937ZM5.325 8.2812C4.2 8.2812 3.2625 7.3437 3.2625 6.2187C3.2625 5.0937 4.2 4.1562 5.325 4.1562C6.45 4.1562 7.3875 5.0937 7.3875 6.2187C7.3875 7.3812 6.4875 8.2812 5.325 8.2812ZM20.4375 21.2937H16.875V15.7437C16.875 14.4312 16.8375 12.7062 15.0375 12.7062C13.2 12.7062 12.9 14.1687 12.9 15.6312V21.2937H9.3375V9.8562H12.75V11.4312H12.7875C13.275 10.5312 14.4375 9.5937 16.1625 9.5937C19.7625 9.5937 20.4375 11.9562 20.4375 15.0312V21.2937Z"
      fill={color}
    />
  </svg>
);

export default LinkedInIcon;
